import { useMemo } from 'react';
import { BoardTypes, IBCTBoard } from 'layouts/pages/bct/types';

// Hook to filter loaded IBCTConfigs by a specific BoardType
export const useFilterHook = (boardType: BoardTypes, configuredBoards: IBCTBoard[]): IBCTBoard[] => {
  const configFilter = useMemo(() => ({ type }: IBCTBoard): boolean => type === boardType, [boardType]);
  const filterBoardConfigs = useMemo(() => configuredBoards?.filter(configFilter), [configFilter, configuredBoards]);
  return filterBoardConfigs;
};
